import { useEffect, useState } from "react";
import type { InstagramAccount } from "../types";

type PageScopedInstagramFetch = (
  facebookPageId: string
) => void | Promise<InstagramAccount[] | void>;

/** Loads Instagram accounts for the selected Facebook page while a surface is open. */
export function usePageScopedInstagramAccounts(
  isOpen: boolean,
  facebookPageId: string | undefined,
  fetchAccounts?: PageScopedInstagramFetch
): InstagramAccount[] {
  const [accounts, setAccounts] = useState<InstagramAccount[]>([]);

  useEffect(() => {
    if (!isOpen) {
      setAccounts([]);
      return;
    }
    const pageId = facebookPageId?.trim();
    if (!pageId || !fetchAccounts) {
      setAccounts([]);
      return;
    }
    let cancelled = false;
    void Promise.resolve(fetchAccounts(pageId)).then((rows) => {
      if (!cancelled) {
        setAccounts(Array.isArray(rows) ? rows : []);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [facebookPageId, fetchAccounts, isOpen]);

  return accounts;
}
